import TopVulnsByKennaDashboardCard from './csa/vuln/topVulnsByKennaDashboardCard.json';
import TopVulnsByImagesDashboardCard from './csa/vuln/topVulnsByImagesDashboardCard.json';
import VulnerabilitiesView from './csa/vuln/vulnerabilitiesView.json';
import VulnerabilitiesTrendline from './csa/vuln/vulnerabilitiesTrendline.json';
import VulnerabilitiesOverviewCard from './csa/vuln/vulnerabilitiesOverviewCard.json';
import VulnCountsBySeverityPie from './csa/vuln/vulnCountsBySeverityPie.json';
import VulnerabilityDetailView from './csa/vuln/vulnerabilityDetailView.json';
import VulnHistogram from './csa/vuln/vulnHistogram.json';

import BtCountsByRiskPie from './csa/bt/btCountsByRiskPie.json';
import BtsView from './csa/bt/btsView.json';
import BtsList from './csa/bt/btsList.json';
import BtDetailView from './csa/bt/btDetailView.json';
import BroHistogram from './csa/bt/broHistogram.json';
import BtsOverviewCard from './csa/bt/btsOverviewCard.json';

import DeploymentsView from './csa/pod/deploymentsView.json';
import PodsList from './csa/pod/podsList.json';
import PodsOverviewCard from './csa/pod/podsOverviewCard.json';
import PodByMisconfigPie from './csa/pod/podByMisconfigPie.json';
import PodDetailView from './csa/pod/podDetailView.json';
import MisconfigIconLabel from './csa/pod/misconfigIconLabel.json';
import WorkloadByMisconfigPie from './csa/pod/workloadByMisconfigPie.json';
import ContainerImagesList from './csa/image/containerImagesList.json';
import ContainerImagesOverviewCard from './csa/image/containerImagesOverviewCard.json';
import ContainerImagesView from './csa/image/containerImagesView.json';
import ContainerImageDetailView from './csa/image/containerImageDetailView.json';

import Container from './csa/common/container.json';
import BroRiskPill from './csa/common/broRiskPill.json';
import TextRiskPill from './csa/common/textRiskPill.json';
import Pill from './csa/common/pill.json';
import BasicCard from './csa/common/basicCard.json';
import MisconfigCellTemplate from './csa/common/MisconfigCellTemplate.json';
import CollapsiblePanel from './csa/common/collapsiblePanel.json';
import ScoreCard from './csa/common/scoreCard.json';
import CheckSubscription from './csa/common/checkSubscription.json';
import CheckAnzenSubscription from './csa/common/checkAnzenSubscription.json';

import LogsView from './csa/logs/logsView.json';

import AppSecurityOverview from './csa/overview/appSecurityOverview.json';
import WelcomeOverview from './csa/overview/welcomeOverview.json';
import RecommendedStepsCard from './csa/overview/recommendedStepsCard.json';
import AlertsOverview from './csa/overview/alertsOverview.json';

export default [
  // vulns
  TopVulnsByKennaDashboardCard,
  TopVulnsByImagesDashboardCard,
  VulnerabilitiesView,
  VulnerabilitiesTrendline,
  VulnerabilitiesOverviewCard,
  VulnCountsBySeverityPie,
  VulnerabilityDetailView,
  VulnHistogram,
  // bts
  BtCountsByRiskPie,
  BtsView,
  BtDetailView,
  BroHistogram,
  BtsOverviewCard,
  BtsList,
  // pods/deployments
  DeploymentsView,
  PodsList,
  PodsOverviewCard,
  PodByMisconfigPie,
  PodDetailView,
  MisconfigIconLabel,
  WorkloadByMisconfigPie,
  // images
  ContainerImagesList,
  ContainerImagesOverviewCard,
  ContainerImagesView,
  ContainerImageDetailView,
  // logs
  LogsView,
  // common
  BroRiskPill,
  TextRiskPill,
  Container,
  BasicCard,
  MisconfigCellTemplate,
  Pill,
  CollapsiblePanel,
  ScoreCard,
  CheckSubscription,
  CheckAnzenSubscription,
  // overview
  AppSecurityOverview,
  WelcomeOverview,
  RecommendedStepsCard,
  AlertsOverview,
];
